var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordpressLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_92)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.0647,
    width: 79.8701,
    height: 79.8701,
    rx: 39.9351,
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1072 38.7123C64.1072 34.4227 62.5644 31.4534 61.2441 29.1417L60.8394 28.4841C59.2359 25.9043 57.8347 23.6381 57.8347 20.9976C57.8347 17.8108 60.2527 14.8365 63.6621 14.8365C63.7632 14.8365 63.8593 14.8466 63.9554 14.8516L64.1123 14.8668C57.7192 8.99466 49.352 5.74094 40.6714 5.75149C34.9183 5.74854 29.2548 7.17707 24.1914 9.90837C19.1279 12.6397 14.8236 16.5879 11.6663 21.3972C12.4757 21.4225 13.2496 21.4428 13.9022 21.4428C17.5291 21.4428 23.149 21.0027 23.149 21.0027C25.0206 20.8914 25.2432 23.6381 23.3716 23.8607C23.3716 23.8607 21.4949 24.0833 19.4007 24.1895L32.0468 61.794L39.6345 39.0006L34.2219 24.1845C32.3554 24.0732 30.5849 23.8557 30.5849 23.8557C28.7133 23.7444 28.9359 20.8813 30.8024 20.9926C30.8024 20.9926 36.5387 21.4327 39.9481 21.4327C43.58 21.4327 49.205 20.9926 49.205 20.9926C51.0767 20.8813 51.2942 23.6331 49.4225 23.8557C49.4225 23.8557 47.5408 24.0732 45.4517 24.1845L57.9966 61.5006L61.4566 49.9319L61.7297 49.0568C63.0955 44.7065 64.1021 41.4944 64.1021 38.7072L64.1072 38.7123ZM5.95535 40.4676C5.95501 46.9866 7.78994 53.3741 11.2502 58.899C14.7104 64.4239 19.6561 68.8631 25.5214 71.7085L8.95501 26.3343C6.97124 30.7817 5.94905 35.5978 5.95535 40.4676Z",
    fill: "#1C85B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8625 73.7675L41.2829 43.5028L51.9512 72.7406C52.022 72.9075 52.1029 73.0644 52.1991 73.2161C45.3218 75.639 37.8558 75.8319 30.8625 73.7675ZM71.1277 23.8103C71.2795 24.9181 71.3655 26.1018 71.3655 27.3816C71.3655 30.9022 70.7079 34.863 68.725 39.8152L58.1225 70.4694C65.9464 65.9236 71.6853 58.5016 74.1157 49.7855C76.5461 41.0693 75.4757 31.7486 71.1328 23.8103H71.1277Z",
    fill: "#1C85B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.203613 40.4675C0.203613 18.1547 18.3584 0 40.6711 0C62.9789 0 81.1387 18.1547 81.1387 40.4675C81.1387 62.7803 62.9789 80.9351 40.6711 80.9351C18.3584 80.9351 0.203613 62.7803 0.203613 40.4675ZM2.06006 40.4675C2.06006 61.7585 19.3802 79.0786 40.6711 79.0786C61.9571 79.0786 79.2772 61.7585 79.2772 40.4675C79.2772 19.1715 61.9571 1.85645 40.6711 1.85645C19.3751 1.85645 2.06006 19.1715 2.06006 40.4675Z",
    fill: "#1C85B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 80.9351,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressLogo);
export default __webpack_public_path__ + "static/media/wordpress_logo.c05072b9da21ef1f1bfa9933ef6f75d8.svg";
export { ForwardRef as ReactComponent };